import React from 'react';
import { servicesSection, services } from '../data/mock';
import { Heart, Footprints, Camera } from 'lucide-react';

const iconMap = {
  heart: Heart,
  footprints: Footprints,
  camera: Camera
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon] || Heart;
  
  return (
    <div className="border border-[#d8d5d0] rounded-lg overflow-hidden bg-white">
      {/* Content - Above Image */}
      <div className="p-6 md:p-8">
        {/* Icon */}
        <div className="mb-4">
          <IconComponent 
            className="w-7 h-7 text-[#5a6b4e]" 
            strokeWidth={1.5}
          />
        </div>
        
        {/* Title */}
        <h3 
          className="text-xl md:text-2xl text-[#3a3a3a] mb-3"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {service.title}
        </h3>
        
        {/* Description */}
        <p 
          className="text-[#6b6b6b] text-sm md:text-base leading-relaxed"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {service.description}
        </p>
      </div>
      
      {/* Image */}
      <div className="aspect-[16/10] overflow-hidden">
        <img 
          src={service.image} 
          alt={service.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
      </div>
    </div>
  );
};

const ServicesSection = React.forwardRef((props, ref) => {
  return (
    <section 
      ref={ref}
      className="bg-[#f5f3ef] py-16 md:py-24 px-6"
    >
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p 
            className="text-[#5a6b4e] text-lg md:text-xl mb-3 italic"
            style={{ fontFamily: "'Pinyon Script', cursive" }}
          >
            {servicesSection.subtitle}
          </p>
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl text-[#3a3a3a] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {servicesSection.title}
          </h2>
          <p 
            className="text-[#6b6b6b] text-base md:text-lg max-w-2xl mx-auto"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {servicesSection.description}
          </p>
        </div>
        
        {/* Services Grid */}
        <div className="space-y-8">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
});

ServicesSection.displayName = 'ServicesSection';

export default ServicesSection;
